import './App.scss';
import { Route, Routes } from 'react-router-dom';
import { Accounts } from 'pages/Accounts/Accounts';
import { AddAccount } from 'pages/AddAccount/AddAccount';
import { Header } from 'components/Header/Header';
import { AllRoutes } from 'constants/routes';
import { AppContext } from 'redux/appReducer';
import { LoginForm } from 'components/LoginForm/LoginForm';
import { useContext } from 'react';
import { GlobalError } from 'components/Error/GlobalError';
import { LogoutBtn } from 'components/logout/LogoutBtn';
import { Albaran } from 'pages/Accounts/Albaran';
import { Facturas } from 'pages/Accounts/Facturas';
import { EditAccount } from 'pages/AddAccount/EditAccount';

function App() {
  const { state } = useContext(AppContext);
  return (
    <div className='App'>
      <Header />
      <main>
        <GlobalError />
        {state.token ? (
          <Routes>
            <Route path={AllRoutes.home} element={<Accounts />}>
              <Route path={AllRoutes.home} element={<Albaran />} />
              <Route path={AllRoutes.facturas} element={<Facturas />} />
            </Route>
            <Route path={AllRoutes.addAccount} element={<AddAccount />} />
            <Route path={'/:id'} element={<EditAccount />} />
            <Route path={`${AllRoutes.facturas}/:id`} element={<EditAccount type={'factura'} />} />
          </Routes>
        ) : (
          <LoginForm />
        )}
        {state.token && <LogoutBtn />}
      </main>
    </div>
  );
}

export default App;
